<template>
  <section class="section" id="operators-panel">
    <div class="container">
      <b-loading
        :is-full-page="true"
        :active="isLoading"
        :can-cancel="false"
      ></b-loading>

      <operators-title
        @get-operators="getOperators"
        @add-operator="addOperator"
      />

      <h2 class="subtitle has-text-centered">
        {{ $t("operators.onlyMerchantAccountCanManageOperators") }}
      </h2>

      <operators-table :operators="operators" @edit-operator="editOperator" />
    </div>

    <b-modal :active.sync="isOperatorModalActive">
      <operator-modal
        :operatorBeingEdited="operatorBeingEdited"
        @get-operators="getOperators"
      />
    </b-modal>
  </section>
</template>

<script>
import { common } from "../../mixins/common";
import { mapGetters } from "vuex";
import operatorsTitle from "./OperatorsTitle";
import operatorsTable from "./OperatorsTable";
import operatorModal from "./OperatorModal";

export default {
  mixins: [common],

  components: {
    operatorsTitle,
    operatorsTable,
    operatorModal
  },

  data() {
    return {
      isLoading: false,
      isOperatorModalActive: false,
      operatorBeingEdited: {}
    };
  },

  methods: {
    getOperators() {
      this.isLoading = true;
      this.$store
        .dispatch("getOperators")
        .then(res => {
          if (res.data.result === "error") {
            this.alertError(res.data);
          }
        })
        .catch(() => {
          this.alertError({ message: "UNEXPECTED_ERROR" });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    addOperator() {
      this.operatorBeingEdited = {};
      this.isOperatorModalActive = true;
    },

    editOperator(operator) {
      this.operatorBeingEdited = JSON.parse(JSON.stringify(operator));
      this.isOperatorModalActive = true;
    }
  },

  computed: {
    ...mapGetters(["operators"])
  },

  mounted() {
    this.getOperators();
  }
};
</script>

<style scoped>
#operators-panel {
  margin-top: 3rem;
  min-height: 94vh;
  padding: 2rem 1rem;
  background-color: hsl(0, 0%, 96%);
}
</style>
